import { useEffect } from 'react';
import { useProductionPlanSearchStore } from '../store';

/**
 * Emphasizes matched tasks in the active view while the results are listed and clears them on unmount.
 * `matchedIds` has to be referentially stable, otherwise highlights are rewritten on every render.
 */
export const useSyncSearchResults = (matchedIds: number[]) => {
  const setSearchResults = useProductionPlanSearchStore((state) => state.setSearchResults);
  const setSearchSelectedTaskId = useProductionPlanSearchStore((state) => state.setSearchSelectedTaskId);

  useEffect(() => {
    setSearchResults(matchedIds);
    setSearchSelectedTaskId(null);

    return () => {
      setSearchResults([]);
      setSearchSelectedTaskId(null);
    };
  }, [matchedIds, setSearchResults, setSearchSelectedTaskId]);
};
